import React from 'react';
import Header from './Header';
import "../assete/css/policy.css";
import terms_vdo from "../assete/image/cancellation-policy-bg.webp"; 
import Whatsapp from './Whatsapp';
import Scrolltop from './Scrolltop';
import Footer from './Footer';

const Cancellationpolicy = () => {
  return (
   <>
   <Header/>
   <div className='seasense_web_policy_div'>
    <img src={terms_vdo} alt=""/> 

        <div className="about_content" >
   
    </div>
    </div> 
        <div className='policy_main_div'>
            <h2>Cancellation Policy</h2>
            <p>Since we're incurring costs and dedicating time, manpower, technology resources and effort to your service or document preparation, our guarantee only covers satisfaction issues caused by sea sense - not changes to your situation or your state of mind. In case you require us to hold the processing of a service, we will hold the fee paid on your account until you are ready to commence the service.</p>
            <p>Before processing any refund, we reserve the right to make best effort to complete the service. In case, you are not satisfied with the service, a cancellation fee of 20% + earned fee + fee paid to government would be applicable. In case of change of service, the cancellation fee would not be applicable.</p>
        </div>
        <Whatsapp/>
        <Scrolltop/>
        <Footer/>
   </>
  )
}

export default Cancellationpolicy